var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waveform-skeleton"},_vm._l((_vm.skeletonBars),function(n){return _c('div',{key:n,staticClass:"skeleton-bar",style:(_vm.getSkeletonBarStyle(n))})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }